"use client";

import React from "react"; 
import Image from "next/image";
import AnimatedCount from "../common/CountUp/AnimatedCount";

export const dynamic = "force-dynamic";

const SnapshotAI = ({ content, path }) => {
    const counterList = content?.services?.map((item, ind) => {
        return (
            <div key={item?.id || ind} className="text-center">
                <div className="grid place-content-center place-items-center">
                    <Image
                        src={`/assets/${path}/${item?.image}.webp`}
                        alt={item?.alt}
                        width={60}
                        height={60}
                    />
                </div>
                <h3 className="my-4 font-manrope text-xl font-bold">
                    {item?.title && item?.title}
                </h3>
                <h4 className="font-manrope text-3xl font-bold">
                     
                    <AnimatedCount end={item?.preDescNumber} suffix={item?.suffix} />

                    {item?.description && item?.description}
                </h4>
            </div>
        );
    });

    return (
        <>
            <div className={`lg:mt-20 mt-16 ${content?.backgroundColor}`}>
                <div className="container mx-auto rounded-[2.25rem] p-14">
                    <h2
                        className={`text-2xl lg:text-3xl leading-snug font-bold font-manrope text-[#410EAD] text-center`}
                    >
                        {content?.title && content?.title}

                        <br />
                        {content?.subtitle && (
                            <span className={`text-black font-manrope`}>
                                {content?.subtitle}
                            </span>
                        )}
                    </h2>

                    <div className="grid gap-4 mt-10 xl:gap-8 md:grid-cols-2 xl:grid-cols-3 place-items-center">
                        {counterList}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SnapshotAI;
